(function() {
    const toTopBtn = document.querySelector('.jsToTopBtn');

    toTopBtn.addEventListener('click', e => {
        e.preventDefault();
        vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
    });

    window.addEventListener('scroll', _ => {
        if (window.scrollY > (window.innerHeight / 4)) {
            toTopBtn.classList.add('visible');
        }
        else {
            toTopBtn.classList.remove('visible');
        }
    });
})();